export const BPC_CARD_WIDTH = '12rem';
